<div class="notification-tray">
  <button type="button" class="bell-button" (click)="toggle()" [attr.aria-expanded]="open()"
    aria-haspopup="dialog" [attr.aria-label]="unreadCount() > 0 ? 'Notifications, ' + unreadCount() + ' unread' : 'Notifications'">
    <i class="fas fa-bell"></i>
    @if (unreadCount() > 0) {
      <span class="bell-badge">{{ unreadCount() > 99 ? '99+' : unreadCount() }}</span>
    }
  </button>

  @if (open()) {
    <div class="tray-panel" role="dialog" aria-label="Notifications">
      <div class="tray-header">
        <strong>Notifications</strong>
        <div class="tray-header-actions">
          <button type="button" class="link-button" (click)="markAllRead()"
            [disabled]="unreadCount() === 0">Mark all as read</button>
          <button type="button" class="link-button" (click)="close()">Close</button>
        </div>
      </div>

      @if (error()) { <p class="tray-note tray-error">{{ error() }}</p> }
      @if (loading()) { <p class="tray-note">Loading…</p> }

      @if (!loading() && notifications().length === 0) {
        <p class="tray-note">You have no notifications yet.</p>
      }

      @if (notifications().length > 0) {
        <ul class="tray-list">
          @for (notification of notifications(); track notification.id) {
            <li>
              <button type="button" class="tray-item" [class.unread]="!notification.isRead"
                (click)="select(notification)">
                <span class="tray-icon"><i [class]="iconClass(notification.category)"></i></span>
                <span class="tray-body">
                  <span class="tray-title">{{ notification.title }}</span>
                  <span class="tray-message">{{ notification.message }}</span>
                  <span class="tray-time">{{ notification.createdDate | date: 'dd MMM yyyy, HH:mm' }}</span>
                </span>
                @if (!notification.isRead) {
                  <span class="unread-dot" aria-hidden="true"></span>
                }
              </button>
            </li>
          }
        </ul>
      }
    </div>
  }
</div>
